"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiImage = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_editor_data_access_ai_1 = require("@desygner/ui-editor-data-access-ai");
const AiImageOverview_1 = require("./AiImageOverview");
function AiImage({ apiBaseUrl, animation, outputFormat = 'base64', company, handleBackButton, imageStyles, imageSizes, insertNewAsset, labels, samplePrompts, userToken, visible = false, }) {
    const api = (0, react_1.useMemo)(() => new ui_editor_data_access_ai_1.AiService(apiBaseUrl, userToken, company), [apiBaseUrl, userToken, company]);
    const handleRequest = (0, react_1.useCallback)((prompt, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { style = '', size } = data || {};
        return yield api.generateImage(prompt, style, outputFormat, size);
    }), [api, outputFormat]);
    return ((0, jsx_runtime_1.jsx)(AiImageOverview_1.AiImageOverview, { visible: visible, animation: animation, labels: labels, outputFormat: outputFormat, samplePrompts: samplePrompts, imageStyles: imageStyles, imageSizes: imageSizes, insertNewAsset: insertNewAsset, onPromptSubmit: handleRequest, onBackButtonClick: handleBackButton }));
}
exports.AiImage = AiImage;
//# sourceMappingURL=AiImage.js.map